import { render, staticRenderFns } from "./SupervisorAssignmentSelect.vue?vue&type=template&id=2b00043e&scoped=true&"
import script from "./SupervisorAssignmentSelect.vue?vue&type=script&lang=js&"
export * from "./SupervisorAssignmentSelect.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorAssignmentSelect.vue?vue&type=style&index=0&id=2b00043e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00043e",
  null
  
)

export default component.exports